export default "__VITE_ASSET__4302fde8__"